import React, {Component} from 'react';
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types';
import {Container, Row, Col, CardGroup, Card, CardBody, Button } from 'reactstrap';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';

import {LoginField} from '../../../views/controls/_FieldValication'
import Messages from '../../../notifications/Messages'
import Errors from '../../../notifications/Errors'
import { logout } from '../../../views/client/actions'
import { validateLoginMfa } from '../../../lib/validation'
import EnvConfig from '../../../config/env'

// Import actions
import loginMfaRequest from './actions';

class LoginMfa extends Component {
  // Pass the correct proptypes in for validation
  static propTypes = {
    handleSubmit: PropTypes.func,
    loginMfaRequest: PropTypes.func,
    logout: PropTypes.func,
    loginMfa: PropTypes.shape({
      requesting: PropTypes.bool,
      successful: PropTypes.bool,
      messages: PropTypes.array,
      errors: PropTypes.array,
    }),
  }
 
  constructor(props) {
    super(props);
    this.cancelClick = this.cancelClick.bind(this);
  }

  submit = (values) => {
    this.props.loginMfaRequest(values, this.props.history)
  }

  cancelClick = () => {
    this.props.logout();
    return this.props.history.push('/login');
  }

  render() {
    const {  
      handleSubmit, // remember, Redux Form injects this into our props
      loginMfa: {
        requesting,
        messages,
        errors,
      },
    } = this.props

    return (
      <div className="app flex-row align-items-center bg-master ">
        <Container>
          <Row>
            <Col md="12">
            <div className="logo">
              <a href={EnvConfig.HTML_REF}>
                  <img alt="Logo" src="../img/logo.png" />
              </a>
            </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md="6" xs="10">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <BlockUi tag="div" blocking={requesting}>
                    <form className="widget-form" method="post" onSubmit={handleSubmit(this.submit)}>
                    <h1>Validate 2 FA</h1>
                    <p className="text-muted">Sign In with token code</p>
                    <Field icon="icon-key" type="number" name="mfa_code" maxLength={6} placeholder="Enter token code" component={LoginField} className="form-control"/>
                    <Row>
                      <Col md="12">
                      {!requesting && !!errors.length && (
                        <Errors message="Failure to signup due to:" errors={errors} />
                      )}
                      {!requesting && !!messages.length && (
                        <Messages messages={messages} />
                      )}  
                      </Col>
                    </Row>
                    <Row>
                      <Col xs="12">
                        <Button disabled={!this.props.valid} color="primary" className="px-4" action="submit">Login</Button>{' '}
                        <Button color="secondary" className="px-4" onClick={this.cancelClick}>Cancel</Button>
                      </Col>
                    </Row>
                    </form>
                    </BlockUi>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

// Grab only the piece of state we need
const mapStateToProps = state => ({
  loginMfa: state.loginMfa,
})

// make Redux state piece of `login` and our action `loginRequest`
// available in this.props within our component
const connected = connect(mapStateToProps, { loginMfaRequest, logout })(LoginMfa)

// in our Redux's state, this form will be available in 'form.login'
const formed = reduxForm({
  form: 'loginMfa',
  validate: validateLoginMfa,
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/Pages/LoginMfa/LoginMfa.js